const helperDatos = ({db, idServicio, MesServicio})=>{
    return new Promise((resolve,reject)=>{
        fetch(`/api/${db}/Busqueda`,
        { 
            method:'POST', 
            body: JSON.stringify({idServicio, MesServicio}), 
            headers:{'Content-Type': 'application/json'}
        })
        .then(response=> response.json())
        .then(result =>{
            if(result.status){
                resolve([]);
            }else{
                resolve(result);
            }
        })
})}

export default helperDatos;